"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ThumbnailMigration", {
    enumerable: true,
    get: function() {
        return ThumbnailMigration;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _common = require("@nestjs/common");
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _lite = /*#__PURE__*/ _interop_require_default(require("mime/lite"));
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _thumbnailgeneratorprocessor = require("~/modules/jobs/jobs/thumbnail-generator/thumbnail-generator.processor");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ThumbnailMigration = class ThumbnailMigration {
    async job() {
        try {
            var _this;
            const sharp = _Noco.default.sharp;
            if (!sharp) {
                this.log(`Thumbnail generation is not supported in this platform at the moment. Skipping thumbnail migration for now!`);
                return true;
            }
            const ncMeta = _Noco.default.ncMeta;
            const storageAdapter = await _NcPluginMgrv2.default.storageAdapter(ncMeta);
            const temp_file_references_table = 'nc_temp_file_references';
            const fileReferencesTableExists = await ncMeta.knexConnection.schema.hasTable(temp_file_references_table);
            // fallback scanning all files if temp table is not generated from previous migration
            if (!fileReferencesTableExists) {
                // create temp file references table if not exists
                await ncMeta.knexConnection.schema.createTable(temp_file_references_table, (table)=>{
                    table.increments('id').primary();
                    table.string('file_path').notNullable();
                    table.string('mimetype');
                    table.boolean('referenced').defaultTo(false);
                    table.boolean('thumbnail_generated').defaultTo(false);
                    table.index('file_path');
                });
                const fileScanStream = await storageAdapter.scanFiles('nc/uploads/**');
                const fileReferenceBuffer = [];
                const insertPromises = [];
                let filesCount = 0;
                let err = null;
                fileScanStream.on('data', async (file)=>{
                    const fileNameWithExt = _path.default.basename(file);
                    const mimetype = _lite.default.getType(_path.default.extname(fileNameWithExt).slice(1));
                    fileReferenceBuffer.push({
                        file_path: file,
                        mimetype,
                        referenced: true
                    });
                    if (fileReferenceBuffer.length >= 100) {
                        try {
                            const processBuffer = fileReferenceBuffer.splice(0);
                            filesCount += processBuffer.length;
                            // skip or insert file references
                            const toSkip = await ncMeta.knexConnection(temp_file_references_table).whereIn('file_path', fileReferenceBuffer.map((f)=>f.file_path));
                            const toSkipPaths = toSkip.map((f)=>f.file_path);
                            const toInsert = processBuffer.filter((f)=>!toSkipPaths.includes(f.file_path));
                            if (toInsert.length > 0) {
                                insertPromises.push(ncMeta.knexConnection(temp_file_references_table).insert(toInsert).catch((e)=>{
                                    this.log(`Error inserting file references`);
                                    this.log(e);
                                    err = e;
                                }));
                            }
                            this.log(`Scanned ${filesCount} files`);
                        } catch (e) {
                            this.log(`There was an error while scanning files`);
                            this.log(e);
                            err = e;
                        }
                    }
                });
                try {
                    await new Promise((resolve, reject)=>{
                        fileScanStream.on('end', resolve);
                        fileScanStream.on('error', reject);
                    });
                    await Promise.all(insertPromises);
                } catch (e) {
                    this.log(`There was an error while scanning files`);
                    this.log(e);
                    throw e;
                }
                filesCount += fileReferenceBuffer.length;
                this.log(`Completed scanning with ${filesCount} files`);
                // throw if there was an async error while scanning files
                if (err) {
                    throw err;
                }
                if (fileReferenceBuffer.length > 0) {
                    await ncMeta.knexConnection(temp_file_references_table).insert(fileReferenceBuffer);
                }
            }
            const numberOfImagesToBeProcessed = (_this = await ncMeta.knexConnection(temp_file_references_table).where('thumbnail_generated', false).andWhere('referenced', true).andWhere('mimetype', 'like', 'image/%').count('*', {
                as: 'count'
            }).first()) == null ? void 0 : _this.count;
            let processedImages = 0;
            const limit = 10;
            const parallelLimit = 1;
            const skipImages = [];
            let processingImages = [];
            const queue = new _pqueue.default({
                concurrency: parallelLimit
            });
            this.log(`Starting thumbnail generation for ${numberOfImagesToBeProcessed} images`);
            const wrapper = async (fileReference, isUrl)=>{
                try {
                    const attachment = {};
                    if (isUrl) {
                        attachment.url = fileReference.file_path;
                        attachment.mimetype = fileReference.mimetype;
                    } else {
                        attachment.path = _path.default.join('download', fileReference.file_path.replace(/^nc\/uploads\//, ''));
                        attachment.mimetype = fileReference.mimetype;
                    }
                    // manually call thumbnail generator job to control the concurrency
                    const thumbnailGenerated = await this.thumbnailGeneratorProcessor.job({
                        data: {
                            context: {
                                base_id: _globals.RootScopes.ROOT,
                                workspace_id: _globals.RootScopes.ROOT
                            },
                            attachments: [
                                attachment
                            ]
                        }
                    });
                    if (thumbnailGenerated.length > 0) {
                        await ncMeta.knexConnection(temp_file_references_table).where('id', fileReference.id).update({
                            thumbnail_generated: true
                        });
                    } else {
                        this.log(`Error generating thumbnail for file ${fileReference.file_path}`);
                        skipImages.push(fileReference.id);
                    }
                } catch (e) {
                    this.log(`Error generating thumbnail for file ${fileReference.file_path}`);
                    this.log(e);
                    skipImages.push(fileReference.id);
                } finally{
                    processedImages += 1;
                    this.log(`Processed ${processedImages} out of ${numberOfImagesToBeProcessed} images`);
                    const processingImage = processingImages.find((p)=>p.id === fileReference.id);
                    if (processingImage) {
                        processingImage.processed = true;
                    }
                }
            };
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (queue.pending > parallelLimit) {
                    await new Promise((resolve)=>setTimeout(resolve, 1000));
                    continue;
                }
                processingImages = processingImages.filter((p)=>!p.processed);
                const fileReferences = await ncMeta.knexConnection(temp_file_references_table).whereNotIn('id', skipImages.concat(processingImages.map((p)=>p.id))).andWhere('thumbnail_generated', false).andWhere('referenced', true).andWhere('mimetype', 'like', 'image/%').limit(limit);
                if (fileReferences.length === 0) {
                    break;
                }
                try {
                    // check if thumbnails exist
                    for (const fileReference of fileReferences){
                        let relativePath;
                        const isUrl = /^https?:\/\//i.test(fileReference.file_path);
                        if (isUrl) {
                            relativePath = (0, _attachmentHelpers.getPathFromUrl)(fileReference.file_path).replace(/^\/+/, '');
                        } else {
                            relativePath = fileReference.file_path;
                        }
                        const thumbnailRoot = relativePath.replace(/nc\/uploads/, 'nc/thumbnails');
                        try {
                            const thumbnails = await storageAdapter.getDirectoryList(thumbnailRoot);
                            if ([
                                'card_cover.jpg',
                                'small.jpg',
                                'tiny.jpg'
                            ].every((t)=>thumbnails.includes(t))) {
                                await ncMeta.knexConnection(temp_file_references_table).where('file_path', fileReference.file_path).update({
                                    thumbnail_generated: true
                                });
                                fileReference.thumbnail_generated = true;
                            }
                        } catch (e) {
                        // ignore error
                        }
                        if (fileReference.thumbnail_generated) {
                            continue;
                        }
                        processingImages.push({
                            id: fileReference.id,
                            processed: false
                        });
                        queue.add(()=>wrapper(fileReference, isUrl));
                    }
                } catch (e) {
                    this.log(`error while generating thumbnail:`, e);
                }
            }
            await queue.onIdle();
        } catch (e) {
            this.log(`There was an error while generating thumbnails for old attachments`);
            this.log(e);
            return false;
        }
        this.log(`Thumbnail generation for old attachments completed successfully`);
        return true;
    }
    constructor(thumbnailGeneratorProcessor){
        this.thumbnailGeneratorProcessor = thumbnailGeneratorProcessor;
        this.debugLog = (0, _debug.default)('nc:migration-jobs:attachment');
        this.log = (...msgs)=>{
            console.log('[nc_job_002_thumbnail]: ', ...msgs);
        };
    }
};
ThumbnailMigration = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _thumbnailgeneratorprocessor.ThumbnailGeneratorProcessor === "undefined" ? Object : _thumbnailgeneratorprocessor.ThumbnailGeneratorProcessor
    ])
], ThumbnailMigration);
